import router from "@/router";
import WA from "@/miniapp/tg";

export const initBackRules = () => {
  let isPopState = false;
  router.options.history.listen((to, from, info) => {
    if (info.direction === "back") {
      isPopState = true;
    }
  });
  router.beforeEach((to, from) => {
    if (to.meta.noBack) {
      WA.hideBackButton();
    } else {
      if (!to.meta.topLevel) {
        WA.showBackButton();
      } else {
        WA.hideBackButton();
      }
    }
    if (isPopState) {
      isPopState = false;
      if (to.name === from.name && from.name && from.query.change) {
        router.back();
        // Взаимоисключение: без return дальше мог сработать и meta.back-переход
        // (двойная навигация).
        return;
      }
      if (from.meta.back) {
        const query = {};
        if (from.meta.back.query) {
          from.meta.back.query.forEach((key) => {
            query[key] = from.query[key];
          });
        }

        // Возвращаем редирект значением, а не router.push внутри гварда — иначе
        // гонка с routerRules-гвардом (тот возвращает redirect, этот пушил напрямую).
        return { name: from.meta.back.to, query };
      }
    }
    isPopState = false;
  });
};
